import Vue from 'vue';
import Router from 'vue-router';
import PlayerOverwiew from '../views/PlayerOverwiew';
import PlayerNew from '../views/PlayerNew';
import PlayerEdit from '../views/PlayerEdit';
import TrainerLogin from '../views/TrainerLogin';
import TrainerRegister from '@/views/TrainerRegister';
import firebase from 'firebase';

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PlayerOverview',
      component: PlayerOverwiew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/TrainerLogin',
      name: 'TrainerLogin',
      component: TrainerLogin,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/TrainerRegister',
      name: 'TrainerRegister',
      component: TrainerRegister,
      meta: {
        requiresAuth: true // Registration temporary disabled. Used to be 'requiresGuest: true'
      }
    },
    {
      path: '/PlayerNew',
      name: 'PlayerNew',
      component: PlayerNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/PlayerEdit/:id',
      name: 'PlayerEdit',
      component: PlayerEdit,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

// Nav Guards
router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)){
    // Chek if logged in
    if(!firebase.auth().currentUser){
      // If not logged in go to login Page
      next({
        path: '/TrainerLogin',
        query: {
          redirect: to.fullPath
        }
      });
    }
    else {
      // Proceed to route
      next();
    }
  }
  // Check for requiresGuest guard
  else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Chek if logged in
    if(firebase.auth().currentUser){
      // If logged in go to "Home" (PlayerOverwiew)
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
    else {
      // Proceed to route
      next();
    }
  }
  else {
    // Proceed to route
    next();
  }
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js